/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Assignees_ChangedInputs */

const en_toast_assignees_changed = /** @type {(inputs: Toast_Assignees_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignees changed`)
};

const de_toast_assignees_changed = /** @type {(inputs: Toast_Assignees_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuständige geändert`)
};

/**
* | output |
* | --- |
* | "Assignees changed" |
*
* @param {Toast_Assignees_ChangedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_assignees_changed = /** @type {((inputs?: Toast_Assignees_ChangedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Assignees_ChangedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_assignees_changed(inputs)
	return en_toast_assignees_changed(inputs)
});